fx.ns("shared.screens", class Saving extends fx.components.ScreenPopup {
    
	constructor(data) {
		super(data);

		this.destroyOnSwitch = true;

		this.effect = "fade";

		// we check if book was saved after 60 secondes
		this.delay(this._onCheckSavingResult, 60000);
	}

	create() {
		super.create();

		let box = new fx.components.Box();

		box.addChild(new shared.component.Person(fx.get("assets").savingPhoto), { width: 260, height: 260, top: 0, left: "center" });

		this._title = new fx.components.Text({ text: fx.text("Je sauvegarde votre oeuvre d'art"), className: "title" });
		this._text = new fx.components.Text({ text: fx.text("Ca sera rapide ..."), className: "text" });

		this._text.effect = "fade";
		this._text.visibleAtStart = false;

		box.addChild(this._title, { width: "100%", height: 40, top: 280, left: "center" });
		box.addChild(this._text, { width: "100%", height: 60, top: 330, left: "center" });

		this._saveButton = new fx.components.Button(fx.text("Ré-essayer"));
		this._saveButton.visibleAtStart = false;

		box.addChild(this._saveButton, { width: "100%", height: 30, top: 390, left: "center" });

		this.addChild(box, { width: 450, height: 460, top: "center", left: "center" });
	}

	onDataEvent(event) {
		super.onDataEvent(event);

		//if (event.type == "creation-saved") {
		//	this.close();
		//}
	}

	onReady() {
		super.onReady();

		this.delay(this._showText, 1000);

		this.delay(this._showExit, 10000);

		this.on("click", this._onSave, this._saveButton);

        this._onCheckSaving();
	}

    onClose()
    {
        this.data.event("show-editor");
    }


	_showText() {
		this._text.show();
	}

	_showExit() {
		this.showClose = true;
	}

    _onCheckSaving()
    {
        if (this.data.saving)
            this.delay(this._onCheckSaving, 5000);
        else
            this.data.save();
    }

	_onCheckSavingResult() {
		if (this.data.saving) {
			this._title.text = fx.text("La sauvegarde a échouée !");
			this._text.text = fx.text("Veuillez ré-essayer.<br>Sinon <a href='/contact' target='_blank'>contacter le service client</a>");

			this._saveButton.show();
		}
		else
			this.data.save();
	}

	_onSave() {
		this.data.save();

		this._saveButton.hide();
		this.delay(this._onCheckSavingResult, 60000);

		this._title.text = fx.text("Je ré-essai !");
		this._text.text = fx.text("Veuillez patienter...");
	}

});

	